import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { PureTextButton, Stack, Text } from '@ltvco/refresh-lib/theme';
import { Close } from '@mui/icons-material';
import { useContext } from 'react';

import { constants } from 'appConstants';

import { useMobileDownloadSnackbar } from '../../hooks/useMobileDownloadSnackbar';

import {
  StyledSnackbar,
  SnackbarContainer,
  StyledIconButton,
} from './DownloadSnackbarComponents.styles';

const APPS_FLYER_LINK = 'https://beenverified.onelink.me/5mdJ/kbh4s7u9';

export const MobileDownloadSnackbar: React.FC = () => {
  const { trackEventGA4 } = useContext(AppConfig);
  const { shouldShowSnackbar, hideSnackbar } = useMobileDownloadSnackbar();

  const handleDownloadClick = () => {
    trackEventGA4({
      event_name: 'navigation click',
      section_name: 'app_snackbar',
      type: 'app_snackbar_download',
      interacted_from: 'beenverified_mobile',
    });
    window.location.href = APPS_FLYER_LINK;
  };

  const handleHideBanner = () => {
    trackEventGA4({
      event_name: 'modal_closed',
      section_name: 'app_snackbar',
      type: 'app_snackbar_close',
      interacted_from: 'beenverified_mobile',
    });
    hideSnackbar();
  };

  if (!shouldShowSnackbar) {
    return null;
  }

  return (
    <StyledSnackbar
      open={shouldShowSnackbar}
      onClose={() => {}}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <SnackbarContainer
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          ml={2}
          spacing={2}
          onClick={handleDownloadClick}
          sx={{ cursor: 'pointer' }}
        >
          <img
            src={constants.images.bvMobileBannerIcon}
            alt="BeenVerifiedMobileBannerIcon"
          />
          <Stack spacing={0.5}>
            <Text variant="h6">View in The BeenVerified App</Text>
            <Text variant="caption" color="text.secondary">
              Rated 4.6 by 24k+ users
            </Text>
          </Stack>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={3}>
          <PureTextButton
            sx={{
              variant: 'h6',
              color: 'primary.main',
              padding: 0,
              minWidth: 0,
            }}
            onClick={handleDownloadClick}
          >
            View
          </PureTextButton>

          <StyledIconButton onClick={handleHideBanner} size="small">
            <Close sx={{ fontSize: '16px' }} />
          </StyledIconButton>
        </Stack>
      </SnackbarContainer>
    </StyledSnackbar>
  );
};
